import React from 'react';
import { MenuGroup, Section } from '@atlaskit/menu';
import { componentWithCondition } from '@atlassian/jira-feature-flagging-utils';
import { fg } from '@atlassian/jira-feature-gating';
import { getWillShowNav4 } from '@atlassian/jira-navigation-apps-sidebar-nav4-rollout-core/src/common/utils/get-will-show-nav4/index.tsx';
import { BoardConnectMenuItems } from '@atlassian/jira-software-connect-toolbar/src/ui/board-connect-menu-items/index.tsx';
import { useBacklogSelector } from '../../../../state/index.tsx';
import { getProjectKey, getRapidViewId } from '../../../../state/selectors/app/index.tsx';
import { operationsSelector } from '../../../../state/selectors/extension/index.tsx';
import ConfigureBoardItem from '../configure-board-item/index.tsx';
import { CreateBoardMenuItem } from '../create-board/index.tsx';
import { FullscreenItem } from '../fullscreen-item/index.tsx';
import ManageCustomFiltersItem from '../manage-custom-filters-item/index.tsx';
import type { Props, MenuItemProps } from '../types.tsx';
import { BoardConnectItems } from './connect-items/index.tsx';
import { BacklogForgeActionMenuItems } from './forge-items/index.tsx';

export type MenuContentProps = Props & MenuItemProps;

const BacklogMenuContentOld = ({
	isCompanyManaged,
	canEditBoardConfig,
	onClosePopup,
}: MenuContentProps) => {
	const boardId = useBacklogSelector(getRapidViewId);
	const projectKey = useBacklogSelector(getProjectKey);
	const onClickWebItem = fg('make_board_menu_popup') ? onClosePopup : undefined;

	return (
		<MenuGroup>
			<Section>
				{isCompanyManaged ? (
					<>
						<ConfigureBoardItem />

						<BoardConnectMenuItems
							boardId={boardId}
							projectKey={projectKey}
							location="board-tools-1"
							mode="plan"
							onClickWebItem={onClickWebItem}
						/>

						{canEditBoardConfig && <CreateBoardMenuItem onClosePopup={onClosePopup} />}

						<BoardConnectMenuItems
							boardId={boardId}
							projectKey={projectKey}
							location="view-actions-print"
							mode="plan"
							onClickWebItem={onClickWebItem}
						/>
					</>
				) : (
					<ManageCustomFiltersItem isDisabled={!canEditBoardConfig} />
				)}
				{fg('forge-ui-project-web-items') && <BacklogForgeActionMenuItems />}
			</Section>
		</MenuGroup>
	);
};

const BacklogMenuContentNew = ({
	isCompanyManaged,
	canEditBoardConfig,
	onClosePopup,
}: MenuContentProps) => {
	const boardId = useBacklogSelector(getRapidViewId);
	const projectKey = useBacklogSelector(getProjectKey);
	const hasOperations = useBacklogSelector(operationsSelector).length > 0;

	return (
		<MenuGroup maxWidth={240}>
			<Section>
				{!fg('blu-5747-fullscreen-in-nav-header') && <FullscreenItem onClosePopup={onClosePopup} />}
				{isCompanyManaged ? (
					<>
						<ConfigureBoardItem />
						{canEditBoardConfig && <CreateBoardMenuItem onClosePopup={onClosePopup} />}
					</>
				) : (
					<ManageCustomFiltersItem isDisabled={!canEditBoardConfig} />
				)}
				{fg('forge-ui-project-web-items') && <BacklogForgeActionMenuItems />}
			</Section>
			<BoardConnectItems
				projectKey={projectKey}
				boardId={boardId}
				hasOperations={hasOperations}
				isCompanyManaged={isCompanyManaged}
			/>
		</MenuGroup>
	);
};

const BacklogMenuContent = componentWithCondition(
	() => getWillShowNav4(),
	BacklogMenuContentNew,
	BacklogMenuContentOld,
);

export default BacklogMenuContent;
